import type { Feature } from "../types/product";

// Dati commerciali: modifica qui nome, prezzo, totali e link di pagamento.
export const product = {
  name: "Belnestore Sostinibile",
  recipesShort: "600+",
  recipesText: "oltre 600",
  recipesTextCap: "Oltre 600",
  volumesCount: 6,
  bonusCount: 5,
  price: "37,00 €",
  checkoutUrl: "https://belnestoresostenibile.impultienda.ar/checkout"
};

// Sostituisci con le immagini reali del tuo materiale (URL completi).
export const images = {
  heroBundle: "https://cdn.magicpatterns.com/patterns/generated-images/1af701b5-47ac-4c79-ab83-e7316f28ba73.jpg",
  recipePage: "https://cdn.magicpatterns.com/patterns/generated-images/b14d7807-5245-4930-bfcf-c4e3787370c1.jpg",
  butters: "https://cdn.magicpatterns.com/patterns/generated-images/aee68963-84bc-4a45-a27f-e5c1ab36a6fd.jpg",
  soaps: "https://cdn.magicpatterns.com/patterns/generated-images/5f6f9917-7462-4590-9c84-22208d30dccd.jpg",
  lips: "https://cdn.magicpatterns.com/patterns/generated-images/3f7b3386-d303-4574-bca9-ea63822bd3bc.jpg"
};
export const galleryImages = [{
  src: images.heroBundle,
  alt: "Il bundle completo: 6 volumi digitali di ricette e 5 bonus"
}, {
  src: images.butters,
  alt: "Cosmetici naturali fatti in casa"
}, {
  src: images.soaps,
  alt: "Cosmetici naturali fatti in casa"
}, {
  src: images.lips,
  alt: "Cosmetici naturali fatti in casa"
}, {
  src: images.recipePage,
  alt: "Esempio di pagina ricetta"
}];

export const heroEyebrow = "Oltre 600 ricette · 6 volumi digitali · 5 bonus inclusi";

export const marqueeItems = ["Oltre 600 ricette", "6 volumi digitali", "5 bonus inclusi", "Anche se parti da zero, passo dopo passo", "Download immediato"];
export const heroFeatures: Feature[] = [{
  title: "Oltre 600 ricette in 6 volumi",
  body: "Tutte le ricette sono organizzate in 6 volumi digitali in PDF, facili da consultare e da tenere sempre a portata di mano."
}, {
  title: "Grammi esatti, niente approssimazioni",
  body: "Ogni ricetta riporta le dosi in grammi e in percentuale, così ottieni sempre lo stesso risultato e puoi aumentare o ridurre le quantità senza errori."
}, {
  title: "Una foto per ogni ricetta",
  body: "Vedi subito come deve apparire il prodotto finito prima di iniziare, per sapere esattamente a cosa stai puntando."
}, {
  title: "Metodo passo dopo passo, anche per principianti",
  body: "Istruzioni chiare con temperature, tempi e consigli pratici. Non serve esperienza: basta seguire i passaggi nell'ordine indicato."
}, {
  title: "Download digitale immediato",
  body: "Subito dopo l'acquisto ricevi via email il link per scaricare tutti i 6 volumi e i 5 bonus. Li apri su telefono, tablet o computer."
}];
export const comparisonRows = [{
  bought: "Un'etichetta che non sai leggere",
  made: "Ingredienti scelti da te"
}, {
  bought: "Il prezzo di un solo barattolo",
  made: "Uno scaffale pieno"
}, {
  bought: "Finisce e lo ricompri",
  made: "Un nuovo lotto quando vuoi"
}, {
  bought: "Lo stesso barattolo di tutti",
  made: "Un barattolo solo tuo"
}];
